<template>
  <div class="container" v-if="isShow">
    <div class="head">
      <div class="title">
        <div class="text">{{assessInfo.assessName}}</div>
        <!-- <div class="tit" @click="navTo()">
          <span>评分细则</span>
        </div> --><!--评分细则隐藏-->
      </div>
      <div class="rules">
        <div class="branch" v-if="assessInfo.deduction>0">-{{assessInfo.deduction}}</div>
        <!-- 没有扣分记录 -->
        <div v-if="Number(assessInfo.deduction)==0" class="no-de">未扣分</div>
        <div class="num">{{assessInfo.score}}/{{assessInfo.totalScore}}</div>
      </div>
    </div>
    <template v-if="recordList&&recordList.length>0">
      <deducList :recordList="recordList" @navToDetail="navToDetail"></deducList>
    </template>
    <!-- 没有扣分记录提示 -->
    <div v-else class="noData-bg">
      <nodata :noData="noData"></nodata>
    </div>
  </div>
</template>
<script>
    import nodata from './components/nodata';// 没有数据
    import deducList from './components/deducList';// 扣分列表
    import api from '../../service/modules/appraise';
    export default {
        components: {
            nodata,
            deducList
        },

        data () {
            return {
                id: '1',
                assessInfo: {},
                assessName: '',
                deduction: 0,
                score: 0,
                noData: {
                    title: '暂无数据'
                },
                recordList: [],
                asscessType: '',
                isShow: false,
                quarterName:this.$route.query.quarterName,
                pageType:this.$route.query.pageType
            }
        },

        computed: {},

        watch: {},

        methods: {
            // 考核明细接口
            getSubAssessScore () {
                this.isShow = false
                api.getSubAssessScoreByArea({ id: this.appraiseId }).then(res => {
                    if (res.ret === 0) {
                        this.isShow = true
                        this.assessInfo = res.data.assessInfo
                        this.recordList = res.data.assessInfo.assessList
                        this.isShow = true
                    } else {
                        this.$Message.error('res.data.msg')
                    }
                });
            },
            navTo () {
                this.$router.push({
                    path: '/appraise/scoringList',
                    query: {
                        asscessType: this.assessInfo.asscessType
                    }
                });
            },
            // 跳转详情页
            navToDetail (subType, row, subName) {
                sessionStorage.setItem('responCont', JSON.stringify(row))
                this.$router.push({
                    path: '/appraise/deductionDetail',
                    query: {
                        subType: subType,
                        subName: subName,
                        quarterName:this.quarterName,
                        pageType:this.pageType
                    }
                });
            }
        },

        mounted () {
        },

        created () {
            this.appraiseId = this.$route.query.id
            this.getSubAssessScore()
        }

    }
</script>
<style scoped lang="less">
  .container {
    min-height: 100vh;
    background: #FBFBFB;
    display: flex;
    flex-direction: column;
    .noData-bg{
      display: flex;
      justify-content: center;
      align-items: center;
      flex: 1;
    }

    .head {
      background: #fff;
      padding: 20px 12px;
      display: flex;
      justify-content: space-between;
      .title {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        padding-right: 50px;
        .text {
          font-size: 20px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: bold;
          color: rgba(51, 51, 51, 1);
          line-height: 28px;
        }
        .tit {
          position: relative;
          display: flex;
          color: #999;
          font-size: 12px;
          margin-top: 12px;
          span{
            position: relative;
            padding-right: 16px;
          }
          span::after{
            content: '';
            position: absolute;
            right: 0;
            top: 50%;
            transform: translateY(-50%);
            width: 12px;
            height: 12px;
            background: url(../../assets/image/t-right.png) no-repeat;
            background-size: 12px 12px;
          }
        }
      }

      .rules {
        display: flex;
        flex-direction: column;
        color: #666666;
        text-align: right;
        .num{
          color: #999999;
          font-size: 14px;
          margin-top: 8px;
        }
        .branch {
          height: 22px;
          font-size: 22px;
          font-family: DIN-Medium, DIN;
          font-weight: 500;
          color: rgba(255, 77, 77, 1);
          line-height: 28px;
        }
        .no-de{
          min-width: 60px;
          font-size:20px;
          font-family:PingFangSC-Medium,PingFang SC;
          font-weight:bold;
          color:rgba(54,179,116,1);
          line-height:22px;
        }

      }
    }

  }
</style>
